import { gql } from '@apollo/client';

/**
 * RITA-1505 (Nutzungserfassung Phase 2c) — häufigste Fehlermeldungen, getrennt abgefragt.
 *
 * Eigenes Dokument, weil der Abschnitt „Fehler“ ein eigenes Fenster hat (die Rohdatenfrist ist
 * kürzer als der verdichtete Zeitraum, deshalb dataFrom/dataUntil hier nochmals) und weil ein
 * Fehler dieser Abfrage sonst die ganze Seite leeren würde: alle Wurzelfelder der Lese-API sind
 * non-null, ein werfender Resolver liefert `data: null` für das gesamte Dokument.
 *
 * `truncated` meldet die Kappung bei 50 000 Rohzeilen; die Zahlen sind dann Untergrenzen der
 * jüngsten Ereignisse. `lastSeenDay` ist tagesgenau — eine Uhrzeit gibt die API bewusst nicht her.
 */
const GET_USAGE_ERRORS = gql`
  query GetUsageErrors($range: UsageRangeInput!) {
    usageErrors(range: $range) {
      dataFrom
      dataUntil
      truncated
      items {
        label
        message
        route
        source
        count
        users
        usersEstimated
        lastSeenDay
        suppressed
        groups
      }
    }
  }
`;

export default GET_USAGE_ERRORS;
